export default __webpack_public_path__ + "static/media/email.0539986d.svg";